import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override parse(value: string): Date | null {
    if (!value) return null;
    const trimmed = value.trim();

    // YYYY-MM-DD (API / copier-coller) : date calendaire locale, pas UTC minuit
    const iso = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (iso) {
      const y = parseInt(iso[1], 10);
      const month = parseInt(iso[2], 10) - 1;
      const day = parseInt(iso[3], 10);
      if (month >= 0 && month < 12 && day > 0 && day <= 31) {
        const d = new Date(y, month, day);
        if (d.getFullYear() === y && d.getMonth() === month && d.getDate() === day) {
          return d;
        }
      }
    }

    // Vérifie si le format est DD/MM/YYYY
    const parts = trimmed.split('/');
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1; // Les mois commencent à 0
      const year = parseInt(parts[2], 10);

      if (
        day > 0 &&
        day <= 31 &&
        month >= 0 &&
        month < 12 &&
        year > 1000 &&
        year < 9999
      ) {
        return new Date(year, month, day);
      }
    }

    // Retourne null si la date n'est pas valide
    return null;
  }

  override format(date: Date, displayFormat: string): string {
    if (!date) return '';
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
}
